import ServiceBase from '@/services/ServiceBase';

const resource = 'api/v1/user-gde';

class UserGestorService extends ServiceBase {
  constructor() {
    super({ resource });
  }

  fastPasswordReset = (passwordResetForm) => {
    const action = 'reset-user-password';
    const url = `${this.resource}${action}/`;
    const response = this.http.post(url, passwordResetForm);
    return response;
  }

  resetMyPassword = (passwordResetForm) => {
    const action = 'reset-my-password';
    const url = `${this.resource}${action}/`;
    const response = this.http.post(url, passwordResetForm);
    return response;
  }
}

export default UserGestorService;



// WEBPACK FOOTER //
// ./src/services/UserGestorService.js